import React, { PureComponent, useState } from 'react';
import { Form, Input, Modal, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import useGlobalState from '~/libs/context';
import { addProject } from '~/libs/requests';
import { InfoBadge } from '~/components/common/InfoBadge';
import { swrInvalidateMany } from '~/libs/helpers';

const CreateProjectModal = (props) => {

  const [ project, setProject ] = useState({ title: '' });
  const [ isBusy, setIsBusy ] = useState(false);

  const onCreateProject = async (ev) => {
    setIsBusy(true);
    const res = await addProject(project);
    swrInvalidateMany('/api/account');
    setIsBusy(false);
    if (res.success) {
      message.success("The project was created.");
      props.onChange(res.data._id);
      props.onClose();
    }
    else {
      message.error(res.message);
    }
  };

  return (
    <Modal title="Create project" open={props.visible} onCancel={props.onClose} confirmLoading={isBusy}
      okText="Create project" onOk={onCreateProject}>
      <Form layout='vertical'>

        <Form.Item label='Name'>
          <Input placeholder="My project (or customer)" onChange={(ev) => setProject({ ...project, title: ev.target.value })} />
        </Form.Item>

      </Form>
    </Modal>
  );
}

export default CreateProjectModal;